export class UsunSrodkiModel {
  srodkiId: Array<string> = new Array();
  idProjektu: string;
}
